import { uniq } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { opinionCounterpartyTypeOptions } from '../../../constants/entity';
import { OpinionScope } from '../../opinions/store/types';
import { SubCounterpartyType } from './types';
import { getSubCounterpartyRoot } from '../../store/selectors';

export const getAvailableSubCounterpartyTypes = (state: ApplicationState): SubCounterpartyType[] => getSubCounterpartyRoot(state).availableOpinionSubCounterpartyTypes;

export const getJurisdictionSubCounterpartyTypes = (state: ApplicationState): SubCounterpartyType[] => getSubCounterpartyRoot(state).jurisdictionalOpinionSubCounterpartyTypes;

export const getSelectedSubCounterpartyType = (state: ApplicationState): SubCounterpartyType | null => getSubCounterpartyRoot(state).selectedSubCounterparty;

export const getSavedSelectedSubCounterpartyType = (state: ApplicationState): SubCounterpartyType | null => getSubCounterpartyRoot(state).savedSelectedSubCounterparty;

export const getOpinionScopesToUpdate = (state: ApplicationState): OpinionScope[] => {
    const currentScopes = getSelectedSubCounterpartyType(state)?.scopes || [];
    const savedScopes = getSelectedSubCounterpartyType(state)?.scopes || [];
    return uniq([...currentScopes, ...savedScopes]);
};

export const getIsEditingSelectedSubCounterparty = (state: ApplicationState): boolean => getSubCounterpartyRoot(state).isEditing;

export const getSelectedSubCounterpartyJurisdiction = (state: ApplicationState): string | null => getSubCounterpartyRoot(state).jurisdiction;

export const getSelectedParentCounterparty = (state: ApplicationState): string | null => getSubCounterpartyRoot(state).parentCounterparty;

export const getIsFetchingSubCounterpartyTypes = (state: ApplicationState): boolean => getSubCounterpartyRoot(state).isFetching;

export const getMultiParentCounterpartyTypes = (state: ApplicationState): string[] => getSubCounterpartyRoot(state).multiParentCounterparties;

export const getSavedParentCounterpartyTypes = (state: ApplicationState): string[] => getSubCounterpartyRoot(state).savedParentCounterparties;

export const getUnavailableParentCounterpartyTypes = (state: ApplicationState): string[] => {
    const currentName = getSelectedSubCounterpartyType(state)?.subCounterpartyName || '';
    const currentScopes = getSelectedSubCounterpartyType(state)?.scopes || [];
    const allSubCounterpartyTypes = getAvailableSubCounterpartyTypes(state);
    const unavailableParentTypes = allSubCounterpartyTypes.filter(({ subCounterpartyName, scopes }) => subCounterpartyName === currentName && scopes.some(scope => currentScopes.includes(scope))).map(({ parentCounterpartyType }) => parentCounterpartyType);
    return unavailableParentTypes;
};

export const getAvailableParentCounterpartyTypes = (state: ApplicationState): string[] => {
    const allParentCounterpartyTypes = opinionCounterpartyTypeOptions;
    const unavailableParentTypes = getUnavailableParentCounterpartyTypes(state);
    return allParentCounterpartyTypes.filter(parentCounterpartyType => !unavailableParentTypes.includes(parentCounterpartyType));
};

export const getSubCounterpartiesToDelete = (state: ApplicationState): SubCounterpartyType[] | null => getSubCounterpartyRoot(state).subCounterpartyTypesToDelete;

export const getIsDeletingSubCounterparties = (state: ApplicationState): boolean => getSubCounterpartyRoot(state).isDeleting;

export const getSubCounterpartyScopeFilters = (state: ApplicationState): OpinionScope[] => getSubCounterpartyRoot(state).scopeFilters;

export const getLinkedSubCounterpartyTypes = (state: ApplicationState): SubCounterpartyType[] => {
    const selectedSubCounterparty = getSelectedSubCounterpartyType(state);
    const currentName = selectedSubCounterparty?.subCounterpartyName || '';
    const allSubCounterpartyTypes = getAvailableSubCounterpartyTypes(state);
    const linkedSubCounterpartyTypes = allSubCounterpartyTypes.filter(({ subCounterpartyName, subCounterpartyTypeId }) => subCounterpartyName === currentName && subCounterpartyTypeId !== selectedSubCounterparty?.subCounterpartyTypeId);
    return linkedSubCounterpartyTypes;
};
